import React from 'react';
import { CnButton } from '@alife/cn-ui';
import '../scss/side-panel.scss';
const clsPrefix = `cn-editor-side-panel`;
const SidePanel = (props) => {
    const { settings } = props;
    if (!settings?.length) {
        return null;
    }
    return (<div className={clsPrefix}>
      {settings.map((btn) => (<CnButton key={btn.id} className={`${clsPrefix}-btn`} onClick={btn.onClick} text>
          <span className={`${clsPrefix}-btn-inner`}>{btn.children}</span>
        </CnButton>))}
    </div>);
};
export default SidePanel;
